module.exports = __webpack_public_path__ + "d295b58ce8f01f8b8a76f6f5ae85bad3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-60@2x.png
// module id = 527
// module chunks = 0